module.exports = __webpack_public_path__ + "static/media/getAppStore.9215bc07.svg";